/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              Midttrafik2016.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var Midttrafik2016 = Midttrafik2016 || {};

// Document ready
$(function () {
    // Only include Novicell functions that you use!
    novicell.responsiveLazyloadImage.image();
    Midttrafik2016.accordion.init();
    Midttrafik2016.header.init();
    Midttrafik2016.mobile.init();
    Midttrafik2016.extranetQuestions.init();
    svg4everybody(); // Fix SVG spritemap in IE/Edge

}); // Document ready end

/*
 *  Use the following if needed
 */

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// Window resize (debounced)
$(window).smartresize(function (e) {
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
    Midttrafik2016.mobile.init();
    Midttrafik2016.accordion.onResize();
    Midttrafik2016.importantlinks.hideImportantLinks();
}); // Window resize
$(window).resize(function (e) {
    Midttrafik2016.importantlinks.equalizeHeight();
    Midttrafik2016.widgets.init();


})
// Window scroll (debounced)
$(window).smartscroll(function (e) {
    novicell.responsiveLazyloadImage.image();

    // call functions here
    novicell.embed.onScroll();


}); // Window scroll

// // Window mousemove (debounced)
// $(window).smartmousemove(function(e){
//     // do stuff as soon as the user stops moving his mouse for longer than 100ms
// }); // Window mousemove

//Browser update Warning! //https://browser-update.org/
var $buoop = {
    vs: {
        i: 10,
        f: 35,
        o: 25,
        s: 7
    },
    c: 2
};

function $buo_f() {
    var e = document.createElement("script");
    e.src = "//browser-update.org/update.min.js";
    document.body.appendChild(e);
};
try {
    document.addEventListener("DOMContentLoaded", $buo_f, false)
} catch (e) {
    window.attachEvent("onload", $buo_f)
}
